// extracted by mini-css-extract-plugin
module.exports = {"image_container":"IconRenderer_image_container__WHxPT","icon":"IconRenderer_icon__3ztq_"};